import { marked, Tokens } from 'marked';

// Renderer for the marked parser which converts md to html. We will add custom rendering for certain components
// See https://marked.js.org/using_pro#renderer for more details
const markedRenderer = new marked.Renderer();
// The link renderer which changes the default rendering of links to open in a new tab
markedRenderer.link = function ({ href, tokens }: Tokens.Link): string {
    console.log(`encoded uri: ${encodeURI(href)}`);
    return `<a href="${encodeURI(href)}" class="
    inline-flex
    min-w-0 items-center gap-1 rounded px-1.5 py-0 transition bg-primary-bubble-link hover:bg-primary-bubble-link-hover text-primary-bubble-link-foreground hover:text-primary-bubble-link-foreground-hover" target="_blank" style="max-width: fit-content;" rel="noopener noreferrer" title="${this.parser.parseInline(tokens)}"><span class="block max-w-[32ch] overflow-hidden [text-overflow:ellipsis] whitespace-nowrap">${this.parser.parseInline(tokens)}</span><img class="size-4 shrink-0" src="/assets/arrow-up-right.svg"/></a>`;
}

const getQueryParam = function (param: string): string | undefined {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(param) ?? undefined;
}

// Formats the date like Thu, October 10 at 5:48 PM
const formatDate = function (dateInt: number): string {
    const date = new Date(dateInt);
    const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'short' });
    const monthDay = date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    return `${dayOfWeek}, ${monthDay} at ${time}`;
}


// This handler can fetch or refresh a component template from the templates library
const componentHandler = (function () {
    // cache the component template
    const templateCache: { [key: string]: string } = {};
    // Function retrieves the template either from the components cache or from the templates library
    // Responds with empty string if not available
    const fetchTemplate = async (templateName: string, refreshTemplate: boolean = false): Promise<string> => {
        if (!refreshTemplate && templateCache[templateName] != null) {
            return templateCache[templateName];
        }
        const templateRequest = await fetch(`/templates/${templateName}.html`);
        if (!templateRequest.ok) {
            return '';
        }
        const templateJson = await templateRequest.text();
        return templateJson;
    }
    return {
        fetchTemplate
    }
})();
const { fetchTemplate } = componentHandler;

export {
    markedRenderer,
    getQueryParam,
    formatDate,
    fetchTemplate
}
